import React from 'react';

const IntroSection = ({ title, paragraphs, imageSrc }) => {
  return (
    <section className="two-column-section">
      <div className="left-column">
        <h2>{title}</h2>
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
      <div className="right-column">
        <div className="image-container">
          <img 
            src={imageSrc} 
            alt="Děti ve škole Maryam"
            style={{ width: '100%', height: 'auto', border: '1px solid #ccc' }} 
          />
        </div>
      </div>
    </section>
  );
};

export default IntroSection; 